/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type StorefrontMediaSection_seller$ref = any;
export type StorefrontMediaSection_seller = {
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly storefrontProfile: {
        readonly galleryAlbum: {
            readonly mediaList: ReadonlyArray<{
                readonly sortOrder: string | null;
                readonly element: ({
                    readonly serviceId?: string | null;
                    readonly path?: string | null;
                    readonly caption?: string | null;
                    readonly mediaType?: string | null;
                    readonly url?: string | null;
                } & ({
                    readonly serviceId: string | null;
                    readonly path: string | null;
                    readonly caption: string | null;
                    readonly mediaType: string | null;
                } | {
                    readonly url: string | null;
                } | {
                    /*This will never be '% other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                })) | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": StorefrontMediaSection_seller$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "caption",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "mediaType",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "StorefrontMediaSection_seller",
        "type": "Seller",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "storefrontId",
                "type": "Int"
            }
        ],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "sellerProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "SellerProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "company",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "storefrontProfile",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "storefrontId",
                        "variableName": "storefrontId"
                    }
                ],
                "concreteType": "StorefrontProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "galleryAlbum",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MediaAlbum",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "mediaList",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MediaElement",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "sortOrder",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "element",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": null,
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "type": "Photo",
                                                "selections": [
                                                    (v0 /*: any*/),
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "path",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    (v1 /*: any*/),
                                                    (v2 /*: any*/)
                                                ]
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "type": "Video",
                                                "selections": [
                                                    (v0 /*: any*/),
                                                    {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "url",
                                                        "args": null,
                                                        "storageKey": null
                                                    },
                                                    (v1 /*: any*/),
                                                    (v2 /*: any*/)
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '10f98e3a8538063690d15c755029b36a';
export default node;
